// Libs
import axios from 'axios';
import { SubmissionError } from 'redux-form'
import _ from 'lodash';

// Actions
import { changeLocalLoading, changeErr, changeSuccess } from '../App/actions'
import { signOut } from '../Deauth/actions'
import { reset } from 'redux-form'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_LAWYER = 'change_lawyer'
export const CHANGE_COMPANY = 'change_company'
export const CHANGE_NEW_INVITATION_CLASSIFIERS = 'change_new_invitation_classifiers'
export const CHANGE_OPTIONAL = 'change_optional'

export const changeLawyer = (lawyer) => {
  return dispatch => {
    dispatch({ type: CHANGE_LAWYER, payload: lawyer })
  }
}

export const changeCompany = (company) => {
  return dispatch => {
    dispatch({ type: CHANGE_COMPANY, payload: company })
  }
}

export const changeNewInvitationClassifiers = (classifiers) => {
  return dispatch => {
    dispatch({ type: CHANGE_NEW_INVITATION_CLASSIFIERS, payload: classifiers })
  }
}

export const changeOptional = (optional) => {
  return dispatch => {
    dispatch({ type: CHANGE_OPTIONAL, payload: optional })
  }
}

export const fetchLawyer = (oabNumber, oabUf) => {
  return dispatch => {
    return serverAPI.get(`/user/lawyer/${oabNumber}/${oabUf}`)
      .then(response => {
        dispatch(changeLawyer(response.data))
        return response.data
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
            dispatch(changeLawyer({}))
        }
      })
  }
}

export const fetchNewInvitationClassifiers = (companyId = null) => {
  return dispatch => {
    return serverAPI.post('/group/classifier', { companyId })
      .then(response => {
        dispatch(changeNewInvitationClassifiers(response.data))
      })
      .catch(e => {
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          default:
        }
      })
  }
}


export const newInvitation = (formData, legalActionId) => {
  return dispatch => {
    dispatch(changeLocalLoading(true))
    return serverAPI.post('case/company', {
      ...formData,
      lawyerName: formData.lawyerName.split(' ', 2)[0],
      lawyerSurname: formData.lawyerName.split(' ', 2)[1]
    })
      .then(response => {
        dispatch(changeLocalLoading(false))
        dispatch(changeSuccess('O convite foi enviado com sucesso. Acompanhe este caso na aba "Meus Casos"'))
        dispatch(reset('newInvitation'))
        dispatch(changeLawyer({}))
        dispatch(changeCompany(''))
        dispatch(changeNewInvitationClassifiers([]))
      })
      .catch(e => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 401:
            dispatch(signOut())
            break
          case 800:
            throw new SubmissionError({ lawyerEmail: 'Este email já está associado a outra OAB' })
          default:
            dispatch(changeErr('Ocorreu um erro no envio do formulário. Entre em contato com um de nossos operadores via chat'))
        }
      })
  }
}
